export function resetParams() {
  return {
    type: '@hooks/RESET',
  };
}
